var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
    m = s && o[s],
    i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import * as React from 'react';
import { isObservableArray } from 'mobx';
import { ClickTracker } from 'bernie-analytics';
import { UitkLink } from 'uitk-react-link';
import { UitkIcon } from 'uitk-react-icons';
import { UitkSpacing } from 'uitk-react-spacing';
import { defaultViewSizes } from '@shared-ui/viewport-context';
export function getGCSectionData(gcContext, sectionName, regionId) {
  var e_1, _a;
  var sections = sectionName === 'header' ? gcContext.header.sections : gcContext.footer.sections;
  if (sections && sections.length > 0) {
    try {
      for (var sections_1 = __values(sections), sections_1_1 = sections_1.next(); !sections_1_1.done; sections_1_1 = sections_1.next()) {
        var section = sections_1_1.value;
        if (regionId === section.templateRegionId) {
          return section;
        }
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (sections_1_1 && !sections_1_1.done && (_a = sections_1.return)) _a.call(sections_1);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
  }
}
export function getApplicableRules(item) {
  if (item && (isObservableArray(item.applicableRules) || Array.isArray(item.applicableRules))) {
    var applicableRules = item.applicableRules.slice();
    return applicableRules.reduce(function (rules, rule) {
      var _a;
      try {
        var _b = __read(rule.split('='), 2),
          name_1 = _b[0],
          value = _b[1];
        return __assign(__assign({}, rules), (_a = {}, _a[name_1] = value, _a));
      } catch (ignored) {
        return rules;
      }
    }, {});
  }
  return {};
}
var sizes = {
  ViewSmall: defaultViewSizes.SMALL,
  ViewMedium: defaultViewSizes.MEDIUM,
  ViewLarge: defaultViewSizes.LARGE,
  ViewExtraLarge: defaultViewSizes.EXTRA_LARGE
};
export var isRuleApplicable = function (item, rule, viewport) {
  switch (rule) {
    case 'hide':
    case 'hideIcon':
    case 'hideText':
      {
        var hide = getApplicableRules(item)[rule];
        return hide === undefined ? false : sizes[hide] <= viewport;
      }
    case 'show':
    case 'showIcon':
    case 'showText':
      {
        var show = getApplicableRules(item)[rule] || 'ViewSmall';
        return sizes[show] <= viewport;
      }
    default:
      return false;
  }
};
export var getComponentsByViewport = function (items, viewport) {
  return items.filter(function (item) {
    return isRuleApplicable(item, 'show', viewport) && !isRuleApplicable(item, 'hide', viewport);
  });
};
export function getGCTypeData(gcContext, sectionName) {
  var sections = sectionName === 'header' ? gcContext.header.sections : gcContext.footer.sections;
  if (sections && sections.length > 0) {
    return sections;
  }
}
export function getHeaderData(globalComponentsContext) {
  var headerImg = getGCSectionData(globalComponentsContext, 'header', 'headerImg');
  var navLinks = getGCSectionData(globalComponentsContext, 'header', 'navLinks');
  var secondaryNavLinks = getGCSectionData(globalComponentsContext, 'header', 'secondaryNavLinks');
  var skipNavText = getGCSectionData(globalComponentsContext, 'header', 'headerSkipNav');
  var coBrandImg = getGCSectionData(globalComponentsContext, 'header', 'cobrandImg');
  var loyaltyText = getGCSectionData(globalComponentsContext, 'header', 'loyaltyTxt');
  var loyaltyItems = getGCSectionData(globalComponentsContext, 'header', 'loyaltyItems');
  var bsa = getGCSectionData(globalComponentsContext, 'header', 'bsa');
  var cobrandPosition = getGCSectionData(globalComponentsContext, 'header', 'cobrandPosition');
  var headerData = {
    headerImg: headerImg,
    navLinks: navLinks,
    secondaryNavLinks: secondaryNavLinks,
    skipNavText: skipNavText,
    coBrandImg: coBrandImg,
    loyaltyText: loyaltyText,
    loyaltyItems: loyaltyItems,
    bsa: bsa,
    cobrandPosition: cobrandPosition
  };
  return headerData;
}
var AnchorLink = function (props) {
  return React.createElement("a", __assign({}, props));
};
var AnchorLinkTracked = ClickTracker(AnchorLink);
export function toMenuItem(link) {
  var _a, _b, _c, _d;
  var Link = link.analytics ? AnchorLinkTracked : AnchorLink;
  var props = {
    href: link.href
  };
  if (link.openInNewTab !== undefined) {
    props.target = link.openInNewTab ? '_blank' : '_self';
  }
  if (((_a = link.attributes) === null || _a === void 0 ? void 0 : _a.role) !== undefined) {
    props.role = (_b = link.attributes) === null || _b === void 0 ? void 0 : _b.role;
  }
  if (((_c = link.attributes) === null || _c === void 0 ? void 0 : _c.tabindex) !== undefined) {
    props.tabIndex = (_d = link.attributes) === null || _d === void 0 ? void 0 : _d.tabindex;
  }
  if (link.rel !== undefined) {
    props.rel = link.rel;
  }
  if (link.analytics) {
    props.events = 'click';
    props.rfrr = link.analytics.id;
    props.linkName = link.id;
    props.trackImmediate = true;
  }
  return link.className === 'uitk-list-item' ? React.createElement(UitkLink, {
    key: link.id,
    className: link.className,
    "data-stid": link.dataStid
  }, React.createElement(Link, __assign({}, props), link.icon && React.createElement(UitkSpacing, {
    padding: {
      inlineend: 'three'
    }
  }, React.createElement(UitkIcon, {
    name: link.icon
  })), link.label, link.openInNewTab && React.createElement("span", {
    className: "screen-reader-select-hidden is-visually-hidden"
  }, "Opens in a new window"))) : React.createElement("hr", {
    key: link.id
  });
}